module.exports = __webpack_public_path__ + "img/example2.bf595ad9.png";